<mat-dialog-content>

  <div class="table-container">
    @if (orderMessages.length > 0) {
      <table mat-table matSort matSortActive="added" matSortDirection="desc" [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z2">
        <ng-container matColumnDef="message">
          <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.message' | transloco }} </th>
          <td mat-cell *matCellDef="let message" class="preserve-line-breaks"> {{ message.message }} </td>
        </ng-container>
        <ng-container matColumnDef="added">
          <th mat-header-cell *matHeaderCellDef mat-sort-header id="added"> {{ 'common.labels.added' | transloco }}
          </th>
          <td mat-cell *matCellDef="let message">
            {{ message.added | localizedDate }}
          </td>
        </ng-container>
        <ng-container matColumnDef="customerRead">
          <th mat-header-cell *matHeaderCellDef>{{isCustomer ? "Read" : "Read By Customer"}}</th>
          <td mat-cell *matCellDef="let message">
            <mat-checkbox class="padding-checkbox" [(ngModel)]="message.isReadByCustomer" [disabled]="!isCustomer" (change)="updateOrderMessage(message)"></mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="adminRead">
          <th mat-header-cell *matHeaderCellDef>{{ 'orderMessages.readByAdmin' | transloco }}</th>
          <td mat-cell *matCellDef="let message">
            <mat-checkbox class="padding-checkbox" [(ngModel)]="message.isReadByAdmin" (change)="updateOrderMessage(message)"></mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="customerVisible">
          <th mat-header-cell *matHeaderCellDef>{{ 'orderMessages.customerVisible' | transloco }}</th>
          <td mat-cell *matCellDef="let message">
            <mat-checkbox class="padding-checkbox" [(ngModel)]="message.isCustomerVisible" (change)="updateOrderMessage(message)"></mat-checkbox>
          </td>
        </ng-container>
        @if (!isCustomer) {
          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let message">
              <button (click)="deleteMessage(message)" mat-icon-button [matTooltip]="'common.buttons.delete' | transloco" matTooltipClass="reghub-tooltip"
                [attr.aria-label]="'orderMessages.deleteMessage' | transloco" color="warn">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>
        }
        <tr mat-header-row *matHeaderRowDef="this.isCustomer ? this.customerDisplayedColumns : this.adminisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: (this.isCustomer ? this.customerDisplayedColumns : this.adminisplayedColumns);">
        </tr>
      </table>
    }
    <lib-placeholder iconName="check_circle" iconClass="icon-success" [message]="'orderMessages.noOrderMessagesFound' | transloco"
    [condition]="orderMessages.length === 0"></lib-placeholder>
    <div>
      <div class="flex-container">
        <h2>{{ 'orderMessages.newMessage' | transloco }}</h2>
      </div>
      @if (!isCustomer) {
        <div class="flex-container">
          <div class="flex-item">
            <mat-checkbox [(ngModel)]="newMessage.isCustomerVisible">
              {{ 'orderMessages.customerVisible' | transloco }}
            </mat-checkbox>
          </div>
        </div>
      }
      @if (isCustomer){
        <div class="flex-container">
          <mat-checkbox class="form-field flex-item" [(ngModel)]="newMessage.isInternalToCustomer">
            {{ 'orderMessages.internalMessageOnlyOnlyMembersOf' | transloco }}
          </mat-checkbox>
        </div>
      }
      <div class="flex-container">
        <mat-form-field class="form-field flex-item">
          <mat-label>{{ 'common.labels.message' | transloco }}</mat-label>
          <textarea matInput [(ngModel)]="newMessage.message" [placeholder]="'common.labels.message' | transloco"></textarea>
        </mat-form-field>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button [mat-dialog-close]="true" class="padding">{{ 'common.buttons.close' | transloco }}</button>
  <span class="spacer"></span>
  <button mat-raised-button
    (click)="saveMessage()" color="accent" class="padding"
    [attr.aria-label]="'orderMessages.saveCorporationButton' | transloco" [class.spinner]="this.isSaving" [disabled]="this.isSaving"
    [mat-dialog-close]="true">
    {{ 'orderMessages.saveNew' | transloco }}
  </button>
</mat-dialog-actions>